import { Option } from '@components/Select/types';

export const getStatusValue = (value: Option[]) => {
  if (!value || value.length === 0) {
    return undefined;
  }

  return value.map((v) => String(v.value));
};
